import {Component, Injector, OnInit} from "@angular/core";
import {HexaDetailComponent} from "@hexalang/ui/core";
import {AuthService} from "@city-tax/features/auth";
import {environment} from "../../../environments/environment";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {EstimateComponent} from "@city-tax/features/individual";


@Component({
  selector: "insource-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
})
export class LandingComponent extends HexaDetailComponent implements OnInit {

  public bsModalRef: BsModalRef;
  config$ = this.authService.config$;
  nowDate = new Date();

  public hasIndividual: boolean = false;
  public hasBusiness: boolean = false;

  constructor(
    injector: Injector,
    private authService: AuthService,
    private modalService: BsModalService
  ) {
    super(injector);
    this.config$?.subscribe((config: any) => {
      if (config) {
        const components = config?.components || {};
        const individual = components?.individual || {};
        const business = components?.business || {};
        this.hasBusiness = business.payments || business.estimates || business.withholdings || business.fillToFile || business.uploadToFile || business.scanToFile;
        this.hasIndividual = individual.payments || individual.estimates || individual.uploadToFile || individual.fillToFile || individual.estimateLookups;
      }
    });
  }

  async ngOnInit() {
    await this.loadConfig();
  }

  async loadConfig() {
    try {
      await this.authService.loadConfig(environment.state, environment.city);
    } catch (error) {
    }
  }

  public onLookup() {
    this.bsModalRef = this.modalService.show(EstimateComponent, {
      initialState: {},
    });
    this.bsModalRef.onHide.subscribe(() => {

    });
  }
}
